module.exports = __webpack_public_path__ + "static/ensaladas-de-lechugas-organicas-1-851abb35aa90f0e9e66b37047f72f485.jpg";